import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/20b010c9c101bc1fcbee07b7dddf944d.jpeg')`
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/30 to-black/40"></div>
      
      {/* Content Container */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-12 gap-12 items-center min-h-[70vh]">
          
          {/* Left Content - Hero Text */}
          <div className="lg:col-span-7 text-white">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-8 border border-white/20">
              <i className="ri-paint-brush-line text-teal-400 mr-2"></i>
              <span className="text-sm font-medium">Est. 2015 • Toronto's Trusted Team</span>
            </div>
            
            {/* Main Headline */}
            <h2 className="text-5xl lg:text-7xl font-black font-inter leading-tight mb-6">
              <span className="block">BRIGHT FINISH</span>
              <span className="block italic font-playfair text-teal-400">STRONG</span>
              <span className="block">FOUNDATION</span>
            </h2>
            
            {/* Subheadline */}
            <p className="text-xl lg:text-2xl font-light text-gray-200 mb-4 max-w-2xl leading-relaxed">
              Quality • Precision • Lasting Results
            </p>
            <p className="text-lg text-gray-300 mb-12 max-w-2xl leading-relaxed">
              Transform your space with expert residential and commercial painting, professional flooring installation, and insulation services you can trust. From custom homes to large commercial projects, we deliver smooth finishes, durable coatings, and flawless flooring — on time, and on budget.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={scrollToQuote}
                variant="primary"
                size="lg"
                className="group"
              >
                Get Free Estimate
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </Button>
              <Button
                onClick={scrollToServices}
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-black"
              >
                View Our Work
              </Button>
            </div>
          </div>
          
          {/* Right Content - Contact Card */}
          <div className="lg:col-span-5 lg:ml-auto">
            <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto lg:mx-0">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Ready to Transform?</h3>
                <p className="text-gray-600">Get your free quote today</p>
              </div>
              
              {/* Contact Info */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-phone-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Call Today</p>
                    <a href="tel:416-648-2980" className="text-lg font-semibold text-gray-900 hover:text-teal-600">
                      416-648-2980
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-mail-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Email Us</p>
                    <a href="mailto:Nisar.noorzai@gmail.com" className="text-lg font-semibold text-gray-900 hover:text-teal-600 break-all">
                      Nisar.noorzai@gmail.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-map-pin-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Service Area</p>
                    <p className="text-lg font-semibold text-gray-900">
                      Flemingdon Park, North York &amp; GTA
                    </p>
                  </div>
                </div>
              </div>
              
              {/* CTA Buttons */}
              <div className="space-y-3">
                <Button
                  onClick={scrollToQuote}
                  variant="secondary"
                  className="w-full"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  Schedule Free Quote
                </Button>
                <button
                  onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  className="w-full py-3 text-center text-teal-600 font-medium hover:text-teal-700 transition-colors border border-teal-200 rounded-lg hover:bg-teal-50"
                >
                  <i className="ri-chat-3-line mr-2"></i>
                  Chat with Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
